import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { API_URL } from '../../../../../../../app-config/constants';
import api from '../../../../../../api';
import { get } from '../../../../../../api/request';
import LoadingIndicatorFull from '../../../../../components/LoadingIndicatorFull';
import { withData } from '../../../../../hoc/withData';
import ObjectiveCycleCreate from '../../lazy';
import { getCopyModel } from '../../services';

function ObjectiveCycleCopyPage({ cycle, allUsers }) {
    const { model: backendModel } = cycle;
    const model = getCopyModel({ ...backendModel, allUsers });
    return <ObjectiveCycleCreate mode="copy" model={model} />;
}

const BASE = `${API_URL}/objective-cycles/guided`;

export default compose(
    setPropTypes({
        cycleId: PropTypes.string.isRequired,
    }),
    withData({
        resolve: {
            cycle: ({ cycleId }) => get(`${BASE}/${cycleId}`),
            allUsers: () => api.usersMedium.getAll(),
        },
        pendingComponent: () => <LoadingIndicatorFull />,
    })
)(ObjectiveCycleCopyPage);
